import Api from "./Api";
import _ from 'lodash';
function transformBeerForApi(beers) {
    let transformedBeers = [];
    for (let index in beers) {
        const beer = beers[index];
        transformedBeers.push({
            additions: beer.spices ? beer.spices : null,
            alc_vol: _.isEmpty(beer.alcVol) ? beer.alcVol : null,
            alternative_cereal: beer.alternativeCereal ? beer.alternativeCereal : null,
            beer_name: beer.name ? beer.name : null,
            category_id: beer.category ? beer.category : null,
            wort_vol: _.isEmpty(beer.wortVol) ? beer.wortVol : null,
            media_file: beer.media_file ? beer.media_file : null,
            query_response: beer.query_response ? beer.query_response : null,
        });
        if (beer.belgianBeerType) {
            transformedBeers[index].additions = beer.belgianBeerType + (beer.spices ? '(' + beer.spices + ')' : '');
        }
    }
    return transformedBeers;
}

export default {
    executeRegistration(registration, language, payment_provider = 'provider_wire') {
        let data = {
            beers: transformBeerForApi(registration.beers),

            company: registration.company.name,
            master_brewer: registration.company.master_brewer,
            future_award: registration.company.future_award,
            street1: registration.company.street1,
            street2: registration.company.street2,
            zip: registration.company.zip,
            city: registration.company.city,
            country_id: registration.company.country,
            url_company: registration.company.url_company,
            po_number: registration.company.po_number,

            contact_email: registration.contact.email,
            contact_fax: registration.contact.fax,
            contact_firstname: registration.contact.firstname,
            contact_lastname: registration.contact.lastname,
            contact_phone: registration.contact.phone,
            contact_salutation: registration.contact.salutation,

            payment_provider: payment_provider === 'nobill' ? null : payment_provider,
            remarks: 'Online-Anmeldung',
            vatid: registration.company.vatid,
            voucher_assigned: registration.vouchercode,
            language_id: language,

            interessent_id: registration.interessent_id,
            createaccount: registration.createUserAccount,
            password: registration.password,
            sendaccountdata: !!registration.createUserAccount,
        };
        if (payment_provider === 'nobill') data.nobill = 1;
        if (registration.hasBilling) {
            data.billing_address_city = registration.billing.city;
            data.billing_address_company = registration.billing.name;
            data.billing_address_country_id = registration.billing.country;
            data.billing_address_street1 = registration.billing.street1;
            data.billing_address_street2 = registration.billing.street2;
            data.billing_address_zip = registration.billing.zip;
        }
        if (registration.hasDeputy) {
            data.deputy_email = registration.deputy.email;
            data.deputy_fax = registration.deputy.fax;
            data.deputy_firstname = registration.deputy.firstname;
            data.deputy_lastname = registration.deputy.lastname;
            data.deputy_phone = registration.deputy.phone;
            data.deputy_salutation = registration.deputy.salutation;
        }
        return Api.post(`/registrations`, data);
    },

    check(registrationId) {
        return Api.get(`registrations/check/${registrationId}`);
    },

    cancel(registrationId) {
        return Api.delete(`registrations/${registrationId}`);
    },
}